import { Injectable } from '@angular/core';

/**
 * This service is used to store and retrieve data related to first time user interactions.
 * This data is storeed in localStorage.
 */
@Injectable({
  providedIn: 'root',
})
export class FirstTimeLocalStorageService {
  readonly BASE_KEY = 'first-time';
  constructor() {}

  /**
   * Gets a value from localStorage.
   * @param featureKey - The key specifying the feature.
   * @param mechanismKey - The key specifying the mechanism.
   * @returns The value from localStorage or null if the key does not exist.
   */
  getLocalStorage(featureKey: string, mechanismKey: string): any | null {
    const value = localStorage.getItem(
      this._generateKey(featureKey, mechanismKey),
    );
    return value ? JSON.parse(value) : null;
  }

  /**
   * Sets a value in localStorage.
   * @param value - The value to set in localStorage; defaults to true.
   * @param featureKey - The key specifying the feature.
   * @param mechanismKey - The key specifying the mechanism.
   */
  setLocalStorage(
    featureKey: string,
    mechanismKey: string,
    value: boolean = true,
  ): void {
    localStorage.setItem(
      this._generateKey(featureKey, mechanismKey),
      JSON.stringify(value),
    );
  }

  /**
   * Checks if the value is the first time the key is being set or if the key does not exist.
   * @param featureKey - The key specifying the feature.
   * @param mechanismKey - The key specifying the mechanism.
   * @returns True if the key is the first time, false otherwise.
   */
  isFirstTime(featureKey: string, mechanismKey: string): boolean {
    return this.getLocalStorage(featureKey, mechanismKey) !== true;
  }

  /**
   * Generates the key for the localStorage item.
   * @param featureKey - The key specifying the feature.
   * @param mechanismKey - The key specifying the mechanism.
   * @returns The key for the localStorage item.
   */
  private _generateKey(featureKey: string, mechanismKey: string): string {
    return `${featureKey}-${this.BASE_KEY}-${mechanismKey}`;
  }
}
